<div mat-dialog-content>
  Sei sicuro di voler cancellare questo evento?
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true">Sì</button>
  <button mat-button [mat-dialog-close]="false">No</button>
</div>
